<template>
  <div class="top-bar__search ">
    <GmapAutocomplete @place_changed="gotoSearch" class="search-input form__input" :placeholder="strings.searchby">
    </GmapAutocomplete>
    <img src="../assets/img/icon-search.svg" class="search-input__icon" alt="Venue Search Icon">
  </div>
</template>

<script>
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAI9vjc_7SMEZlkMh3V36I7vRKkxDBk8uI",
    v: "GOOGLE_MAPS_VERSION",
    libraries: "places"
  }
});

export default {
  data() {
    return {
      place: null
    };
  },
  methods: {
    gotoSearch(place) {
      this.place = place;
      let site_url = window.location.origin;
      let lang = this.$store.state.selectedLang;
      if(lang == 'en'){
        lang = '';
      } else {
        lang = '/' + lang;
      }
      if (this.place) {
        let url = '';
        if(window.isWL == 1){
          url = lang + "/wlsearch?pt=" +
          this.place.geometry.location.lat() +
          "," +
          this.place.geometry.location.lng();
        } else {
          url = lang + "/search?pt=" +
          this.place.geometry.location.lat() +
          "," +
          this.place.geometry.location.lng();
        }

        if(window.location.hostname == 'connect.cwteasymeetings.com'){
          url += '&duration=3&delegates=5';
        } else {
          url += '&duration=8&delegates=10';
        }

        window.location.href = url;
      } else {
        return false;
      }
    }
  },
  computed: {
    strings () {
      return this.$store.state.strings
    }
  }
};
</script>